const projectsPageTitle = document.querySelector('.pf-8_');
// const body = document.querySelector('body');
const fixBtnElement = document.getElementById('fix-button');

// Add to project page

if (projectsPageTitle?.textContent === 'Projects') {
  const body = document.querySelector('body');
  const header = document.getElementById('shopify-section-header');
  const sideMenucontent = document.createElement('div');
  sideMenucontent.innerHTML = `
    <div class="side-floating-menu">
      <ul>
        <h2><a href="#shopify-section-header">Projects</a></h2>
        <div class="sidecontents">
          <li><a href="#cafe"><img src="https://cdn.shopify.com/s/files/1/0569/6366/1998/t/2/assets/pf-abb38b02--cafe.jpg?v=1622017714" alt="カフェ" loading="lazy" width="40" height="30"></a></li>
          <li><a href="#event"><img src="https://cdn.shopify.com/s/files/1/0569/6366/1998/t/2/assets/pf-a5d61e97--IMG4157.jpg?v=1622016861" alt="イベント・アウトドア" loading="lazy" width="40" height="30"></a></li>
          <li><a href="#club"><img src="https://cdn.shopify.com/s/files/1/0569/6366/1998/t/2/assets/pf-701395f6--IMG4594.jpg?v=1622081357" alt="クラブ" loading="lazy" width="40" height="30"></a></li>
          <li><a href="#bar"><img src="https://cdn.shopify.com/s/files/1/0569/6366/1998/t/2/assets/pf-468d1a1c--Bar.jpeg?v=1622082277" alt="バー・シーシャ" loading="lazy" width="40" height="30"></a></li>
          <li><a href="#gym"><img src="https://cdn.shopify.com/s/files/1/0569/6366/1998/t/2/assets/pf-67cdfc00--training.jpg?v=1622081712" alt="ジム" loading="lazy" width="40" height="30"></a></li>
          <li><a href="#beauty"><img src="https://cdn.shopify.com/s/files/1/0569/6366/1998/t/2/assets/pf-bf2c544d--BeautySalon.jpeg?v=1622092164" alt="美容室・エステ・ネイルサロン" loading="lazy" width="40" height="30"></a></li>
          <li><a href="#hobby"><img src="https://cdn.shopify.com/s/files/1/0569/6366/1998/t/2/assets/3-1661159714523.png?v=1661159735" alt="推し活・アイドル・コスプレ" loading="lazy" width="40" height="30"></a></li>
          <li><a href="#food"><img src="https://cdn.shopify.com/s/files/1/0569/6366/1998/t/2/assets/pf-5c9f465c--Restaurant.jpeg?v=1622090883" alt="飲食店" loading="lazy" width="40" height="30"></a></li>
          <li><a href="#display"><img src="https://cdn.shopify.com/s/files/1/0569/6366/1998/t/2/assets/pf-4b7a33ec--41B7A2C3FCBD431D941E5D8579119AF3.jpeg?v=1622106084" alt="店舗ディスプレイ・ファザード" loading="lazy" width="40" height="30"></a></li>
          <li><a href="#music"><img src="https://cdn.shopify.com/s/files/1/0569/6366/1998/t/2/assets/pf-4200fee1--MusicSchool.jpeg?v=1622090980" alt="音楽" loading="lazy" width="40" height="30"></a></li>
          <li><a href="#flower"><img src="https://cdn.shopify.com/s/files/1/0569/6366/1998/t/2/assets/pf-aa0894dd--FlowerShop.jpeg?v=1622091404" alt="花屋" loading="lazy" width="40" height="30"></a></li>
          <li><a href="#christmas"><img src="https://cdn.shopify.com/s/files/1/0569/6366/1998/t/2/assets/pf-51906202--Christmas.jpeg?v=1622081599" alt="クリスマス" loading="lazy" width="40" height="30"></a></li>
          <li><a href="#halloween"><img src="https://cdn.shopify.com/s/files/1/0569/6366/1998/t/2/assets/pf-19da5950--halloween.jpeg?v=1622082382" alt="ハロウィン" loading="lazy" width="40" height="30"></a></li>
          <li><a href="#birthday"><img src="https://cdn.shopify.com/s/files/1/0569/6366/1998/t/2/assets/pf-343a678b--Events.jpeg?v=1622091859" alt="誕生日" loading="lazy" width="40" height="30"></a></li>
          <li><a href="#wedding"><img src="https://cdn.shopify.com/s/files/1/0569/6366/1998/t/2/assets/pf-5fcc96ad--Wedding.jpeg?v=1622091526" alt="結婚式" loading="lazy" width="40" height="30"></a></li>
          <li><a href="#living"><img src="https://cdn.shopify.com/s/files/1/0569/6366/1998/t/2/assets/pf-67cfd7f0--livingroom.jpg?v=1622090794" alt="リビング" loading="lazy" width="40" height="30"></a></li>
          <li><a href="#bedroom"><img src="https://cdn.shopify.com/s/files/1/0569/6366/1998/t/2/assets/pf-33ddb9a8--bed.jpg?v=1622082612" alt="ベッドルーム" loading="lazy" width="40" height="30"></a></li>
          <li><a href="#animal"><img src="https://cdn.shopify.com/s/files/1/0569/6366/1998/t/2/assets/pf-f1df5c20--animal.jpg?v=1622081858" alt="どうぶつ" loading="lazy" width="40" height="30"></a></li>
          <li><a href="#fashion"><img src="https://cdn.shopify.com/s/files/1/0569/6366/1998/t/2/assets/pf-3fe1f6b6--IMG4153.jpg?v=1622082504" alt="ファッション" loading="lazy" width="40" height="30"></a></li>
          <li><a href="#kids"><img src="https://cdn.shopify.com/s/files/1/0569/6366/1998/t/2/assets/pf-7a33ecee--6A6B7414D83B4489BD3454F6951B9203.jpeg?v=1622106105" alt="キッズ" loading="lazy" width="40" height="30"></a></li>
        </div>
      </ul>
    </div>
    `;
  header.append(sideMenucontent);
    // body.appendChild(sideMenucontent);
}

// Get specific attributes
// page title
const elProjects = document.querySelector('.pf-6_');
elProjects?.setAttribute('id', 'projects');
// cafe
const elCafe = document.querySelector('.pf-12_');
elCafe?.setAttribute('id', 'cafe');

const elEvent = document.querySelector('.pf-38_');
elEvent?.setAttribute('id', 'event');

const elClub = document.querySelector('.pf-64_');
elClub?.setAttribute('id', 'club');

const elBar = document.querySelector('.pf-116_');
elBar?.setAttribute('id', 'bar');

const elGym = document.querySelector('.pf-139_');
elGym?.setAttribute('id', 'gym');

const elBeauty = document.querySelector('.pf-139_');
elBeauty?.setAttribute('id', 'beauty');

const elHobby = document.querySelector('.pf-162_');
elHobby?.setAttribute('id', 'hobby');

const elFood = document.querySelector('.pf-184_');
elFood?.setAttribute('id', 'food');

const elDisplay = document.querySelector('.pf-207_');
elDisplay?.setAttribute('id', 'display');

const elMusic = document.querySelector('.pf-233_');
elMusic?.setAttribute('id', 'music');

const elFlower = document.querySelector('.pf-259_');
elFlower?.setAttribute('id', 'flower');

const elChristmas = document.querySelector('.pf-281_');
elChristmas?.setAttribute('id', 'christmas');

const elHalloween = document.querySelector('.pf-307_');
elHalloween?.setAttribute('id', 'halloween');

const elBirthday = document.querySelector('.pf-329_');
elBirthday?.setAttribute('id', 'birthday');

const elWedding = document.querySelector('.pf-355_');
elWedding?.setAttribute('id', 'wedding');

const elLiving = document.querySelector('.pf-381_');
elLiving?.setAttribute('id', 'living');

const elBedroom = document.querySelector('.pf-404_');
elBedroom?.setAttribute('id', 'bedroom');

const elAnimal = document.querySelector('.pf-427_');
elAnimal?.setAttribute('id', 'animal');

const elFashion = document.querySelector('.pf-453_');
elFashion?.setAttribute('id', 'fashion');

const elKids = document.querySelector('.pf-475_');
elKids?.setAttribute('id', 'kids');

// Move sidebar content
const height = document.body.clientHeight;
const sideContents = document.querySelector('.sidecontents');
window.addEventListener('scroll', () => {
  const position = window.pageYOffset;
  if (sideContents) {
    sideContents.style.transform = `translateY(-${position / 700}px)`;
  }
});

// Get header height size not aviod header cover
const headerHeight = document.getElementById(
  'shopify-section-header'
).clientHeight;
const sideFloatingMenu = document.querySelector('.side-floating-menu');
document.addEventListener('scroll', function () {
  const headerHeight = document.getElementById(
    'shopify-section-header'
  ).clientHeight;
  const sideScrollY = window.pageYOffset;
  if (headerHeight && sideFloatingMenu) {
    if (sideScrollY > headerHeight) {
      if (sideFloatingMenu) {
        sideFloatingMenu.setAttribute('style', 'display:fixed;');
        sideFloatingMenu.setAttribute('style', 'top:0;');
      }
    } else {
      sideFloatingMenu.style.top = `${headerHeight}px`;
    }
  }
});
